import {
	Component,
	EventEmitter,
	Input,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { ApiService } from "./services/api.service"
import { StoreService } from "./services/store.service"
import { ModalService } from "./services/modal.service"
import { COMMON_IMPORTS } from "./common-imports"
import { ModalWrapComponent } from "./modal-wrap/modal-wrap.component"
import { PromptInputFieldComponent } from "./prompt-input-field/prompt-input-field.component"

@Component({
	selector: "app-get-next-id",
	imports: [COMMON_IMPORTS, ModalWrapComponent, PromptInputFieldComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		@if (modalProps) {
			<app-modal-wrap
				(onClose)="modalProps = null; handleClose()"
				title="edit_num"
				modalWrapperClass="modal-small-width"
			>
				<app-prompt-input-field
					(onClose)="modalProps = null; handleClose($event)"
					[bodyTitle]="'first_' + doctype + '_num'"
					[num]="modalProps.num"
				/>
			</app-modal-wrap>
		}
	`,
})
export class GetNextIdComponent {
	@Input() doctype: string = ""
	@Output() onDone = new EventEmitter()
	modalProps: any = null

	constructor(
		private apiService: ApiService,
		private store: StoreService,
		private modalService: ModalService
	) {}
	async ngOnInit() {
		const res: any = await this.apiService.post("get_next_projected_id", {
			tableName: `${this.doctype}s`,
		})
		if (!res?.isNew) {
			this.onDone.emit(res.nextId)
			return
		}
		this.modalProps = { num: this.store.cc()[`${this.doctype}_num`] || 1 }
	}
	handleClose(newId: any = null) {
		//if user has not defined "invoice_num" - make them define it.
		const num = Number(newId)
		if (num <= 0 || Number.isNaN(num)) {
			this.modalService.openToast("first_invoice_num_error")
			this.onDone.emit(null)
			return
		}

		const cliniqData = this.store.cc()
		const fieldName = `${this.doctype}_num`
		cliniqData[fieldName] = num
		sessionStorage.setItem("cliniqData", JSON.stringify(cliniqData))
		const obj: any = { [fieldName]: newId }
		this.apiService.post("update_configcliniq_data", {
			...obj,
			update: "taxes",
		})
		this.onDone.emit(num)
	}
}
